import api from './api';

export const planService = {
    getFeatureCatalog: async () => (await api.get('/admin/plans/feature-catalog')).data,
    getAllPlans: async () => (await api.get('/admin/plans')).data,
    createPlan: async (payload) => (await api.post('/admin/plans', payload)).data,
    updatePlan: async (id, payload) => (await api.patch(`/admin/plans/${id}`, payload)).data,
    deletePlan: async (id) => (await api.delete(`/admin/plans/${id}`)).data
};
